import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ReactNode,
} from 'react'
import styles from './RangoLink.module.css'

type CommonProps = {
  children: ReactNode
  /**
   * Ícone à esquerda. O DS exige ícone no *Link Icon*; no fluxo ACUL há links
   * de texto puros (ex.: "Esqueci minha senha"), sem ícone — exceção
   * documentada em docs/guia-copy-a11y.md.
   */
  icon?: ReactNode
  className?: string
}

type AnchorProps = CommonProps &
  AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; onClick?: never }

type ActionProps = CommonProps &
  ButtonHTMLAttributes<HTMLButtonElement> & { href?: undefined }

export type RangoLinkProps = AnchorProps | ActionProps

function content(children: ReactNode, icon?: ReactNode) {
  return (
    <>
      {icon ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span className={styles.label}>{children}</span>
    </>
  )
}

/**
 * Link Rango DS — cor primária, sublinhado no hover, área de toque
 * `$size-6x` (48px) e foco visível (anel roxo) quando é uma ação.
 * Com `href` vira `<a>`; sem `href` vira `<button type="button">`.
 */
export function RangoLink(props: RangoLinkProps) {
  if ('href' in props && typeof props.href === 'string') {
    const { children, icon, className, ...rest } = props as AnchorProps
    return (
      <a
        className={[styles.link, className].filter(Boolean).join(' ')}
        {...rest}
      >
        {content(children, icon)}
      </a>
    )
  }
  const { children, icon, className, ...rest } = props as ActionProps
  return (
    <button
      type="button"
      className={[styles.link, styles.action, className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {content(children, icon)}
    </button>
  )
}
